<template>
    <div>
        <div class="row mt-4">
            <div class="col-12 ea-reports">
                <div v-for="(item, rindex) in reports" :key="rindex" class="ea-reports-border">
                <div class="report_heading_1">{{ item.name }}</div>
                <div class="report_heading_2">
                    <router-link :to="item.link" class="btn btn-primary btn-sm btn-view-report">
                        View Report
                    </router-link>
                </div>
                <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['accountId'],
    data() {
        return{
            reports: [
                { name: 'Competency Report', link: '/enterprise-admin/competency-report-overview/' + this.accountId },
                { name: 'Rep Audit Trail Report', link: '/enterprise-admin/rep-audit-trail/' + this.accountId },
                // { name: 'Forms Report', link: '' },
            ],
        }
    },
    methods: {
        getLocationDetail(accountId) {
            if (accountId > 0) {
                this.accountId = accountId;
                this.loading = true;
                this.account = [];
                this.overview = {};
                axios('/enterprise-admin/location-overview',
                {
                    method: 'GET',
                    params: {
                        account_id: accountId,
                    }
                })
                .then(resp => {
                    this.loading = false;
                    this.$parent.account = resp.data;
                })
                .catch(() => {
                });
            }
        }
    }
}
</script>
<style scoped>
/* reports tab css */
.report_heading_1 { width: 70%; float: left; text-align: left; font-weight: 900; }
.report_heading_2 { width: 30%; float: left; text-align: right; font-weight: 900; }
.ea-reports { margin: 0 1rem; }
.ea-reports-border { border-bottom: 1px solid #CCC; width: 95%; margin: 1rem 0; }
.ea-reports-border:nth-last-child(1) { border-bottom: 0 none; }
.btn-view-report, .btn-view-report:active, .btn-view-report:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 8px;
  font-size: 13px;
  margin: 5px;
}
/* reports tab css */
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/reports_tab.vue